module.exports = __webpack_public_path__ + "img/product-12.1127f1b6.jpg";